import * as abpTypings from '../lib/abp';
import moment, { Moment } from 'moment';
import { L } from '../lib/abpUtility';
import { routers } from '../components/Router/router.config';

declare var abp: any;

class Utils {
  //动态添加script
  loadScript(url: string) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    document.body.appendChild(script);
  }

  extend(...args: any[]) {
    let options,
      name,
      src,
      srcType,
      copy,
      copyIsArray,
      clone,
      target = args[0] || {},
      i = 1,
      length = args.length,
      deep = false;
    if (typeof target === 'boolean') {
      deep = target;
      target = args[i] || {};
      i++;
    }
    if (typeof target !== 'object' && typeof target !== 'function') {
      target = {};
    }
    if (i === length) {
      target = this;
      i--;
    }
    for (; i < length; i++) {
      if ((options = args[i]) !== null) {
        for (name in options) {
          src = target[name];
          copy = options[name];
          if (target === copy) {
            continue;
          }
          srcType = Array.isArray(src) ? 'array' : typeof src;
          if (deep && copy && ((copyIsArray = Array.isArray(copy)) || typeof copy === 'object')) {
            if (copyIsArray) {
              copyIsArray = false;
              clone = src && srcType === 'array' ? src : [];
            } else {
              clone = src && srcType === 'object' ? src : {};
            }
            target[name] = this.extend(deep, clone, copy);
          } else if (copy !== undefined) {
            target[name] = copy;
          }
        }
      }
    }

    return target;
  }

  //根据路径得到页面标题
  getPageTitle = (pathname: string) => {
    const findRoute = (routes, path) => {
      for (const route of routes) {
        if (route.path === path) {
          return route;
        }
        if (route.children) {
          const childRoute = findRoute(route.children, path);
          if (childRoute) {
            return childRoute;
          }
        }
      }
      return null;
    };

    const route = findRoute(routers, pathname);
    const localizedAppName = abp.utils.getCookieValue('Abp.Login.UserType') == "IWorld" ? "iWorld" : "MSP";
    if (!route) {
      return localizedAppName;
    }

    return L(route.title) + ' | ' + localizedAppName;
  };

  getRoute = (path: string): any => {
    return routers.filter((route) => route.path === path)[0];
  };

  setLocalization() {
    if (!abp.utils.getCookieValue('Abp.Localization.CultureName')) {
      let language = 'zh-Hans';
      abp.utils.setCookieValue(
        'Abp.Localization.CultureName',
        language,
        new Date(new Date().getTime() + 5 * 365 * 86400000),
        abp.appPath
      );
    }
  }

  getCurrentClockProvider(currentProviderName: string): abpTypings.timing.IClockProvider {
    if (currentProviderName === 'unspecifiedClockProvider') {
      return abp.timing.unspecifiedClockProvider;
    }

    if (currentProviderName === 'utcClockProvider') {
      return abp.timing.utcClockProvider;
    }

    return abp.timing.localClockProvider;
  }

  // 文件流转blob对象下载
  downloadFile(url) {
    let downloadElement = document.createElement('a');
    downloadElement.href = url;
    downloadElement.click();
  }

  expandOrCollapseAll = (pageRef) => {
    const { basicMotorInfoDtos, expandConfig } = pageRef.state;
    const expandedRowKeys = basicMotorInfoDtos.data?.map((item) => item.id) ?? [];
    const isExpanded = expandConfig.isExpanded;

    if (isExpanded) {
      pageRef.setState({
        expandConfig: {
          ...expandConfig,
          expandedRowKeys: [],
          isExpanded: false,
          expandText: '全部展开'
        },
      });
    } else {
      pageRef.setState({
        expandConfig: {
          ...expandConfig,
          expandedRowKeys: expandedRowKeys,
          isExpanded: true,
          expandText: '全部折叠'
        },
      });
    }
  };

  //#region 预占法定节假日相关

  /**
 * 判断某一天是否为无效日期（节假日或周末）
 * @param {moment} date - 要判断的日期（Moment 对象）
 * @returns {boolean} true 表示该日期不可用
 */
  isInvalidDate = (date, holidays) => {
    const dateString = date.format('YYYY-MM-DD');

    // 查找是否存在于 holidays 列表中
    const holidayItem = holidays.find(
      (item) => item.dateString === dateString
    );

    // 如果存在且是节假日或周末，则为无效
    if (holidayItem) {
      //return (holidayItem.holiday && !holidayItem.workDay) || (holidayItem.weekend && !holidayItem.workDay);
      return !holidayItem.workDay;
    }

    // 日历无记录时，按星期判断周末
    const dayOfWeek = date.day();
    return dayOfWeek === 0 || dayOfWeek === 6;
  };

  /**
   * 获取接下来的 3 个有效工作日
   */
  getValidDates = (holidays) => {
    const today = moment().startOf('day');
    const isAfterCutoff = moment().hour() >= 15;
    const result = [];
    let currentDate = today.clone();

    // 15:00 后跳过「明天」，从后天开始找有效工作日
    currentDate = currentDate.add(isAfterCutoff ? 2 : 1, 'days');

    while (result.length < 3) {
      if (!this.isInvalidDate(currentDate, holidays)) {
        result.push(currentDate.clone());
      }
      currentDate = currentDate.clone().add(1, 'days');
    }

    return result;
  };

  /**
   * 计算接下来的 3 个有效工作日并设置到组件 state
   */
  calculateValidDates = (thisObj) => {
    const result = this.getValidDates(thisObj.state.holidays);
    thisObj.setState({ validDates: result });
  };

  //#endregion

  // 递归转换key的函数
  deepTransformKeys = (obj: any, transformFn: (key: string) => string): any => {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    if (Array.isArray(obj)) {
      return obj.map(item => this.deepTransformKeys(item, transformFn));
    }

    const result: Record<string, any> = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const newKey = transformFn(key);
        result[newKey] = this.deepTransformKeys(obj[key], transformFn);
      }
    }
    return result;
  }

  jsonKeyToLowerCase = (obj: any): any => {
    return this.deepTransformKeys(obj, key => key.charAt(0).toLowerCase() + key.slice(1))
  }

  naturalSort = (arr: Array<any>, property: string = null): Array<any> => {
    if (!arr || !Array.isArray(arr)) {
      return [];
    }
    return arr.sort((a, b) => {
      const aValue = property ? a[property] : a;
      const bValue = property ? b[property] : b;

      // 处理 undefined 或 null 值
      if (aValue === undefined || aValue === null) return 1;
      if (bValue === undefined || bValue === null) return -1;

      // 将字符串拆分为数字和字母部分
      const regex = /(\d+|[A-Za-z]+)/g;
      const aParts = aValue.match(regex) || [];
      const bParts = bValue.match(regex) || [];

      // 比较每一部分
      const minLength = Math.min(aParts.length, bParts.length);

      for (let i = 0; i < minLength; i++) {
        const aPart = aParts[i];
        const bPart = bParts[i];

        // 如果两部分都是数字，按数值比较
        if (!isNaN(aPart) && !isNaN(bPart)) {
          const numA = parseInt(aPart, 10);
          const numB = parseInt(bPart, 10);
          if (numA !== numB) {
            return numA - numB;
          }
        } else {
          // 如果一部分是数字，一部分是字母，数字优先
          if (!isNaN(aPart) && isNaN(bPart)) {
            return -1;
          }
          if (isNaN(aPart) && !isNaN(bPart)) {
            return 1;
          }
          // 如果都是字母，按字母顺序比较
          if (aPart !== bPart) {
            return aPart.localeCompare(bPart);
          }
        }
      }

      // 如果前面部分都相同，按长度排序
      return aParts.length - bParts.length || aValue.localeCompare(bValue);
    });
  }

  /**
 * 如果 price 可以解析为有效数字，则返回四舍五入后的整数字符串（无小数点）；
 * 否则直接返回原 price 字符串。
 * @param {string} price - 待处理的价格字符串
 * @returns {string} 处理后的字符串
 */
  displayPrice = (price) => {
    if (price === null || price === undefined) {
      return price;
    }

    const priceStr = typeof price === 'string' ? price : String(price);
    if (priceStr.trim() === '') {
      return priceStr;
    }

    const num = parseFloat(priceStr.trim());

    if (!isNaN(num) && isFinite(num)) {
      return num.toLocaleString('en-US');
    }

    return priceStr;
  }

  safeParseInt = (value, defaultValue = 0, radix = 10) => {
    if (typeof value === 'string') {
      const parsed = parseInt(value, radix);
      return isNaN(parsed) ? defaultValue : parsed;
    }
    const num = Number(value);
    return isNaN(num) ? defaultValue : num;
  };

  safeParseFloat = (value, defaultValue = 0) => {
    if (typeof value === 'string') {
      const parsed = parseFloat(value);
      return isNaN(parsed) ? defaultValue : parsed;
    }
    const num = Number(value);
    return isNaN(num) ? defaultValue : num;
  };

  parseJinCategoryCode = (code: string): string => {
    if (!code || !code.startsWith('J')) {
      return '';
    }
    const parts = code.substring(1).split('.');
    if (parts.length < 3) {
      return '';
    }
    
    const sceneMap: Record<string, string> = {
      '1': '行业型',
      '2': '客户型',
      '3': '延伸性',
      '4': '一次性项目'
    };
    
    const vcMap: Record<string, string> = {
      '1': '内含VC',
      '2': '不含VC'
    };
    
    const priceMap: Record<string, string> = {
      '1': '面价',
      '2': '一口价'
    };
    
    const scene = sceneMap[parts[0]] || '';
    const vc = vcMap[parts[1]] || '';
    const price = priceMap[parts[2]] || '';
    
    const result = [scene, vc, price].filter(Boolean);
    return result.join('，');
  };
}

export default new Utils();
